import { TYPE_OF_SUBPARTS } from "@typings/priceSubparts";

const PRICE_SUBPARTS: Record<TYPE_OF_SUBPARTS, string> = {
  [TYPE_OF_SUBPARTS.VOUCHER]: "priceSubpartVoucher",
  [TYPE_OF_SUBPARTS.BALANCE]: "priceSubpartBalance",
  [TYPE_OF_SUBPARTS.DISCOUNT]: "priceSubpartDiscount",
  [TYPE_OF_SUBPARTS.SUBTOTAL]: "priceSubpartSubtotal",
  [TYPE_OF_SUBPARTS.URSSAF]: "priceSubpartUrssaf",
};

export const getPriceSubpartTestId = (type: TYPE_OF_SUBPARTS): string =>
  PRICE_SUBPARTS[type];
